export default __webpack_public_path__ + "static/its_not_you2-e8bb1c426259038c19ce476bf5a14d7f.png";